export var UserTypeOptions;
(function (UserTypeOptions) {
    UserTypeOptions["Member"] = "Member";
    UserTypeOptions["Visitor"] = "Visitor";
    UserTypeOptions["NewVisitor"] = "New Visitor";
})(UserTypeOptions || (UserTypeOptions = {}));
export var DataLayerEventNameOptions;
(function (DataLayerEventNameOptions) {
    DataLayerEventNameOptions["UaEvent"] = "UniversalAnalyticsEvent";
    DataLayerEventNameOptions["UaPageView"] = "UniversalAnalyticsPageView";
    DataLayerEventNameOptions["CriteoEvent"] = "CriteoEvent";
})(DataLayerEventNameOptions || (DataLayerEventNameOptions = {}));
